import { useParams } from "react-router-dom";
import { TournamentLoader } from "pages/TournamentLoader";
import { TourPageContent } from "./TourPageContent";
import { ErrorMessagePage } from "pages/PageTemplates";
import { selectTour } from "selectors/Tour";
import { getTourTournamentIds } from "model/Tour/Tour";
import { useAppSelector } from "app/hooks";

export const TourPage = () => {
  const { id, tabName } = useParams();

  const tour = useAppSelector((state) => selectTour(state, id));
  if (!tour || !id) {
    return <ErrorMessagePage message="Tour Could Not Be Found" />;
  }

  return (
    <TournamentLoader tournamentIds={getTourTournamentIds(tour)}>
      <TourPageContent tour={tour} tabName={tabName} />
    </TournamentLoader>
  );
};
